<div>
  <div class="dialog-close">
    <span class="material-symbols-outlined" role="button" tabindex="0" (click)="closeModal()">close</span>
  </div>

  <article class="modal-content">

    <section class="redirection-notice">
      <h1>
        Please note that you're leaving the {{this.aspName}} website.
      </h1>
    </section>

    <section class="redirection-description">
      <h2>
        While we recommend this site, we aren't responsible for its content. It may have different terms, conditions and
        privacy policies that you'll need to follow.
      </h2>
    </section>

    <section class="buttons">
      <button mat-raised-button color="primary" type="button" (click)="goToVendorUrl()" id="vendor-redirect">OK</button>
      <button mat-raised-button class="accent" (click)="closeModal()">Cancel</button>
    </section>

  </article>

</div>
